import {
  ChangeDetectionStrategy,
  Component,
  input,
  WritableSignal,
  inject,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { RouterLink } from '@angular/router';
import { GoBackDirective } from '@core-utils';
import { BreadcrumbInterface, BreadcrumbService } from './breadcrumb.service';

@Component({
  selector: 'ui-breadcrumb',
  imports: [NgClass, TranslocoPipe, RouterLink, GoBackDirective],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [BreadcrumbService],
})
export class BreadcrumbComponent {
  private breadcrumbService = inject(BreadcrumbService);

  PAGE_ROUTES = input.required<{ [key: string]: string }>();
  breadcrumbs: WritableSignal<BreadcrumbInterface[]> =
    this.breadcrumbService.breadcrumbs;

  getFirstSegment(url: string): string {
    return url.split('/')[1];
  }
}
